import { OwcIcon, OwcListItem, OwcMenu, OwcProgressSpinner } from '@one/react';
import { useIsSmallScreen } from 'common/hooks/use-is-small-screen.hook';
import { useId } from 'react';
import { LanguageInlineOption, LanguageTriggerPrefix } from './language-selector.style';
import { useLanguageSelector } from './use-language-selector.hook';

export const LanguageSelectorComponent: React.FC = () => {
  const {
    languages,
    currentLanguage,
    currentLanguageText,
    isSavingLanguage,
    visible,
    setVisible,
    toggle,
    close,
    select,
  } = useLanguageSelector();
  const isSmallScreen = useIsSmallScreen();
  const triggerId = `language-selector-${useId().replaceAll(':', '')}`;

  const renderTriggerPrefix = () => {
    if (isSavingLanguage) {
      return (
        <LanguageTriggerPrefix slot="prefix">
          <OwcProgressSpinner size="small" />
        </LanguageTriggerPrefix>
      );
    }
    if (isSmallScreen) {
      return (
        <LanguageTriggerPrefix slot="prefix" $open={visible}>
          <OwcIcon name="chevron_right" family="outlined" />
        </LanguageTriggerPrefix>
      );
    }
    return <OwcIcon slot="prefix" name="chevron_left" family="outlined" />;
  };

  const handleToggle = (event: React.MouseEvent) => {
    event.stopPropagation();
    toggle();
  };

  const renderOptions = (Option: typeof OwcListItem) =>
    languages.map(language => (
      <Option
        key={language.value}
        onClick={event => {
          event.stopPropagation();
          select(language.value);
        }}
      >
        {language.text}
        {language.value === currentLanguage ? (
          <OwcIcon slot="suffix" name="confirm" family="outlined" />
        ) : undefined}
      </Option>
    ));

  return (
    <>
      <OwcListItem
        id={triggerId}
        disabled={isSavingLanguage}
        aria-busy={isSavingLanguage}
        aria-expanded={visible}
        onClick={handleToggle}
      >
        {renderTriggerPrefix()}
        <span>{currentLanguageText}</span>
      </OwcListItem>
      {isSmallScreen ? (
        visible && renderOptions(LanguageInlineOption)
      ) : (
        <OwcMenu
          anchor={triggerId}
          trigger="manual"
          position="left"
          strategy="fixed"
          visible={visible}
          autoCloseOnSelection={false}
          onVisibleChange={event => setVisible(event.detail)}
          onClickOutside={close}
          onClick={event => event.stopPropagation()}
        >
          {renderOptions(OwcListItem)}
        </OwcMenu>
      )}
    </>
  );
};
